export const MERGE_INVALID_STATUSES = ['released', 'ready2release', 'discarded']

export const OCG_MERGE_BANNED_CLIENT_IDS = [3939, 3941]

export const MATTER_TOOLTIP_OPEN_DELAY = 1000
export const MATTER_REMOVE_SELECTOR = '[data-matter-remove]'
export const MATTER_REMOVE_TITLE = 'Remove this matter from the entry'
export const MATTER_SEARCH_POPUP_SELECTOR = '.search-combobox-popup'
export const MATTER_SEARCH_IGNORED_CLASSES = [
  'k-i-x',
  'k-input-inner',
  'k-i-caret-alt-down',
]
export const MATTER_SEARCH_FIELDS =
  'obj_id,name,number,client_id,client_number,client_name,is_billable,type,utbms_required'
export const MATTER_COMBO_BOX_CONFIG = {
  field: 'matter',
  labelFields: ['number', 'name'],
  value: 'number',
  separator: ' ',
  valueLabel: 'Matter Number',
  nameLabel: 'Matter Name',
  typeLabel: 'Matter',
}
